<template>
  <div id="page-wrapper">
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">
          {{$t('deposit.title')}}
          <a class="btn-settings" href="/client/deposit"><i class="fa fa-cog"></i></a>
        </h1>
      </div>
      <!-- /.col-lg-12 -->
    </div>
    <!-- /.row -->
    <div class="row">
      <div class="col-lg-4 col-xl-4 col-xxl-3">
        <div class="panel panel-default">
          <div class="panel-footer">
            <total-balance></total-balance>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-xl-8 col-xxl-9">
        <div class="panel panel-default">

          <div class="panel-body">

            <div class="form-group row">
              <div class="col-sm-12 col-md-12">
                <div :class="status != 'approved' ? 'alert alert-danger' : 'alert alert-success'" role="alert">
                  <strong>{{data.status}}:</strong> {{data.message}}
                </div>
                <div>
                  <a :href="data.transactionUrl" target="_blank">{{data.transactionUrl}}</a>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-12 col-md-12">
                <button type="button" class="btn btn-default mrg-b-25" v-on:click="goToDashboard">{{$t('shared.buttons.back_home')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  import DepositService from '@/services/DepositService';

  let srv = new DepositService();

  export default {

    data() {
      return {
        result: {},
        data: ''
      };
    },
    methods: {
      goToDashboard(){
        this.$router.push('/client');
      }
    },
    created() {
      this.status = this.$route.query.status;
      let uid = this.$route.query.uid ? this.$route.query.uid : 0;
      if (uid !== 0) {
        srv.getTransaction(this.$route.query.psp, uid).then((r) => {
          this.data = r.data;
        });
      } else {

        let r_status = 'deposit.results.' + this.status + '.status';
        let r_message = 'deposit.results.' + this.status + '.message';

        this.data = {
          status: this.$t(r_status),
          message: this.$t(r_message)
        };
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/views/Transaction.vue